// import hooks
import { useQuery, UseQueryOptions } from 'react-query';

// import queries & mutations
import { getWorkAgreements } from 'RestAPIs/employees/leave-requests';

// import types
import {
  EmployeeWorkAgreementProps,
  QueryFnType,
  QueryKeyType
} from './useGetEmployeeWorkAgreements.types';

const useGetEmployeeWorkAgreements = (
  { startDate, endDate, employeeId }: EmployeeWorkAgreementProps,
  queryOptions?: UseQueryOptions<
    QueryFnType,
    unknown,
    QueryFnType,
    QueryKeyType
  >
) => {
  // convert once, so the query key holds exactly what is sent to the endpoint
  const start = startDate ? startDate.toISOString() : null;
  const end = endDate ? endDate.toISOString() : null;

  const { data, isFetching, isError, refetch } = useQuery(
    ['employeeWorkAgreements', employeeId, start, end],
    async () => {
      if (!start || !end) {
        return [];
      }

      const { data } = await getWorkAgreements({
        startDate: start,
        endDate: end,
        employeeId
      });
      return data;
    },
    {
      enabled: !!start && !!end && !!employeeId,
      ...queryOptions
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeWorkAgreements;
